import { COUNTRY } from '@/config';

const AGENT_URL = `${window.location.origin}/agente`;

const AGENT_URL_CREATE = {
  br: `${AGENT_URL}/criar`,
  mx: `${AGENT_URL}/crear`,
  es: `${AGENT_URL}/crear`,
};

export const AGENT_FACTORY_URL_HOME = AGENT_URL;
export const AGENT_FACTORY_URL_CREATE = AGENT_URL_CREATE[COUNTRY];
